import React, { useState } from "react";
import { Flex, Modal } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import HButton from "../../../components/custom/input/button/Button";
import { useWorkflowStore } from "../store";
import { selectSelectedStep } from "../store/selectors";

const DELETE_STEP_CONFIRM_TITLE = "Delete this step?";
const DELETE_STEP_CONFIRM_CONTENT =
    "This step will be removed from the workflow. You can add it back later if needed.";

export interface ConfigPanelFooterProps {
    primaryLabel: string;
    onPrimaryClick: () => void;
    primaryDisabled?: boolean;
}

export const ConfigPanelFooter: React.FC<ConfigPanelFooterProps> = ({
    primaryLabel,
    onPrimaryClick,
    primaryDisabled = false,
}) => {
    const selectedStep = useWorkflowStore(selectSelectedStep);
    const deleteStep = useWorkflowStore((s) => s.deleteStep);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleDeleteClick = () => setShowDeleteConfirm(true);
    const handleDeleteConfirm = async () => {
        if (!selectedStep) return;
        setConfirmLoading(true);
        deleteStep(selectedStep.id);
        setShowDeleteConfirm(false);
        setConfirmLoading(false);
    };
    const handleDeleteCancel = () => setShowDeleteConfirm(false);

    return (
        <>
            <Flex className="trigger-rule-config-panel__footer justify-content-between gap-3 flex-wrap">
                <HButton
                    variant="cancel"
                    prefixIcon={<DeleteOutlined />}
                    onClick={handleDeleteClick}
                    buttonClassName="trigger-rule-config-panel__btn-delete"
                >
                    Delete Step
                </HButton>
                <HButton type="primary" onClick={onPrimaryClick} disabled={primaryDisabled}>
                    {primaryLabel}
                </HButton>
            </Flex>
            <Modal
                open={showDeleteConfirm}
                onCancel={handleDeleteCancel}
                centered
                width={400}
                className="campaignOverviewEdit"
                footer={
                    <div className="d-flex align-items-center justify-content-between gap-2 mt-3 m-2">
                        <HButton
                            variant="cancel"
                            buttonClassName="w-100 me-2 h-45 hs-fw-500"
                            onClick={handleDeleteCancel}
                        >
                            <span className="hs-fs-14 hs-fw-500 hs-color-text-grey-3">Cancel</span>
                        </HButton>
                        <HButton
                            buttonClassName="w-100 ms-2 h-45 hs-fw-600"
                            type="primary"
                            onClick={handleDeleteConfirm}
                            loading={confirmLoading}
                        >
                            Delete
                        </HButton>
                    </div>
                }
            >
                <div className="d-flex align-items-start justify-content-between">
                    <div className="pt-1">
                        <ExclamationCircleOutlined className="text-danger fs-4" />
                    </div>
                    <button
                        type="button"
                        className="btn btn-link p-0 border-0 text-decoration-none"
                        onClick={handleDeleteCancel}
                        aria-label="Close delete confirmation"
                    >
                        <div className="actionIconsSprite closeIconBig" />
                    </button>
                </div>
                <div className="hs-fs-16 hs-fw-600 hs-color-BlackRussian mb-1 mt-2">{DELETE_STEP_CONFIRM_TITLE}</div>
                <div className="pb-3">{DELETE_STEP_CONFIRM_CONTENT}</div>
            </Modal>
        </>
    );
};
